import axios from 'axios'


export default {
  
  fetchForms: () => axios.get('/forms/'),
  fetchFormInfo: formId => axios.get('/forms/fetchFormInfo/'+formId),
  fetchOne: id => axios.get('/forms/' + id),
  createForm: (form) => axios.post('/forms/createNewForm', form),
  filterForms: criteria => axios.post('/forms/searchForms', criteria),
  updateForm: (form) => axios.put('/forms/editForm',form)
  
}
